import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as Api from '../../store/csw/csw.api';
import * as Actions from '../../store/csw/csw.actions';
import { noop } from 'ui-components/default-props/noop';

export const useNeedsCustomsState = (fulfillmentPlanId) => {
  const dispatch = useDispatch();
  const updateNeedsCustoms = useCallback(
    (shipFromId, shipTo, sellerLabelProviderId, shippingServiceId, sellerFulfillmentProviderId, isReturn) => {
      if (sellerFulfillmentProviderId || isReturn) {
        return new Promise((resolve) => resolve(false));
      }
      const shipToParams = {
        city: shipTo?.city,
        state: shipTo?.state,
        postalCode: shipTo?.postalCode,
        countryCode: shipTo?.countryCode,
      };
      const payload = {
        fulfillmentPlanId,
        shipFromId,
        shipTo: shipToParams,
        sellerLabelProviderId,
        shippingServiceId,
      };

      return Api.getNeedsCustomsRequirements(payload)
        .then((data) => {
          const newNeedsCustomsRequirements = data?.data;
          dispatch(Actions.updateNeedsCustomsRequirements(fulfillmentPlanId, newNeedsCustomsRequirements));
          return newNeedsCustomsRequirements;
        })
        .catch(noop);
    },
    [dispatch, fulfillmentPlanId],
  );

  return {
    updateNeedsCustoms,
  };
};
